var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import AddressCard from './AddressCard';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import AddressForm from './AddressForm';
import { useConfirm } from '../../../hooks/confirmationHook';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { roaster as roasterApi, roasterAddress as addressApi, } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
var AddressList = function (_a) {
    var type = _a.type, roaster = _a.roaster, reloadRoaster = _a.reloadRoaster;
    var t = useTranslation().t;
    var _b = React.useState(), editingAddress = _b[0], setEditingAddress = _b[1];
    var notify = useNotify();
    var confirm = useConfirm();
    var destroyAddress = useRequest(addressApi.destroy);
    var updateRoaster = useRequest(roasterApi.update);
    var startCreateAddress = React.useCallback(function () {
        setEditingAddress(buildNewAddress(type));
    }, [type]);
    var startEditAddress = React.useCallback(function (address) {
        setEditingAddress(address);
    }, []);
    var addresses = React.useMemo(function () {
        var _a, _b;
        if (type === 'delivery')
            return (_a = roaster.deliveryAddresses) !== null && _a !== void 0 ? _a : [];
        return (_b = roaster.billingAddresses) !== null && _b !== void 0 ? _b : [];
    }, [type, roaster]);
    var closeDialogAndRefleshRoaster = React.useCallback(function () {
        reloadRoaster();
        setEditingAddress(undefined);
    }, [reloadRoaster]);
    var startDeleteAddress = React.useCallback(function (address) {
        confirm('', t('messages.deleteConfirm'), function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, destroyAddress({
                            roasterId: roaster.id,
                            id: address.id,
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response)
                            return [2 /*return*/];
                        notify('success', [t('messages.deleteSuccess')]);
                        closeDialogAndRefleshRoaster();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [t, notify, confirm, roaster, destroyAddress, closeDialogAndRefleshRoaster]);
    var setAsDefault = React.useCallback(function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = address.addressType === 'billing'
                        ? { default_billing_address_id: address.id }
                        : { default_delivery_address_id: address.id };
                    return [4 /*yield*/, updateRoaster({ id: roaster.id, roaster: params })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    closeDialogAndRefleshRoaster();
                    return [2 /*return*/];
            }
        });
    }); }, [updateRoaster, roaster, closeDialogAndRefleshRoaster]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { textAlign: "right" },
            React.createElement(Button, { variant: "contained", onClick: startCreateAddress }, t('buttons.addItem'))),
        React.createElement(Grid, { container: true, spacing: 2 }, addresses.map(function (address) { return (React.createElement(Grid, { key: address.id, item: true, xs: 12, sm: 6 },
            React.createElement(AddressCard, { address: address, onEdit: startEditAddress, onDelete: startDeleteAddress, onSetAsDefault: setAsDefault }))); })),
        React.createElement(FullScreenDialog, { open: Boolean(editingAddress), onClose: function () { return setEditingAddress(undefined); } }, editingAddress && (React.createElement(AddressForm, { roaster: roaster, address: editingAddress, onSuccess: closeDialogAndRefleshRoaster })))));
};
export default AddressList;
var buildNewAddress = function (addressType) { return ({
    id: '',
    addressType: addressType,
    billingName: '',
    storeName: '',
    personName: '',
    nameKana: '',
    phone: '',
    countryCallingCode: '',
    email: '',
    countryCode: '',
    postalCode: '',
    prefecture: '',
    city: '',
    address: '',
    building: '',
    isDefault: false,
    editable: true,
}); };
